import React from 'react';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';
import { addAlert, removeAlert } from 'redux/session/actions';
import { useDispatch } from 'react-redux';
import { useEventListener, useComponentMount } from 'utilities/hooks.util';

const alertId = 'user-limit';

const Users: React.FC = () => {
  const dispatch = useDispatch();
  useEventListener(
    'message',
    (event: MessageEvent) => {
      if (event.data === 'Show alert for user limit') {
        dispatch(
          addAlert(
            'warning',
            'Limit reached',
            'Maximum number of users reached. To add more, please contact your organisation administrator.',
            false,
            0,
            alertId
          )
        );
      }
    },
    window
  );

  useComponentMount(() => {
    return () => {
      dispatch(removeAlert(alertId));
    };
  });
  return (
    <div id="Users" data-testid="Users" className="users-managament">
      <FullHeaderLeftSideFullPanelLayout enableHeaderGlobalBar={true}>
        <iframe
          title="Locate 1.0"
          src={`${process.env.REACT_APP_CURRENT_VERSION_URL}/administrator/users?iframe=true`}
          scrolling="no"
          frameBorder="no"
          width="100%"
          height="100%"
        />
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};

export default React.memo(Users);
